import { cloneDeep } from 'lodash'
import { mapState } from 'vuex'

import { BasketHelper } from '@/helpers/Basket'
import RequestManager from '@/helpers/RequestManager'

import { CollectiveHelper } from '@/helpers/Collective'

const basketQueue = RequestManager.getQueue('basket')

export default {
  computed: {
    /**
     * Map all store states privately - we don't like access directly
     * @private states
     */
    ...mapState({ $_basket: 'basket' }),
  },

  methods: {
    /**
     * Update current basket
     *
     * It will checks if we need to update the collective or product structure
     *
     * @param {BasketPayload} payload
     *    @param {String} payload.basketId  Session id from the basket
     *    @param {String} payload.jwToken  Hash jwt token
     * @param {Object} params  Extended put url parameters
     * @returns {Promise<Basket>}
     */
    updateBasket(payload, params = {}, simulate = false) {
      const storeBasket = cloneDeep(this.$_basket)

      let updatePayload = cloneDeep(payload)

      let reloadProducts =
        updatePayload?.collective?.contractNumber !== storeBasket.collective?.contractNumber ||
        updatePayload?.contractStartDate !== storeBasket.contractStartDate ||
        updatePayload?.language !== storeBasket.language

      let _updateBasket = simulate
        ? this.$backend.ovp.simulateUpdateBasket(updatePayload, params)
        : this.$backend.ovp.updateBasket(updatePayload, params)
      return _updateBasket
        .then(basket => {
          if (reloadProducts && basket.collective?.contractNumber) {
            return CollectiveHelper.loadCollective(basket, true)
          }

          if (basket.contractStartDate !== updatePayload.contractStartDate) {
            reloadProducts = true
          }

          return basket
        })
        .then(basket => BasketHelper.updateBasketSession(basket))
        .then(basket => (reloadProducts ? BasketHelper.getAndSetProducts(basket) : basket))
        .catch(error => Promise.reject(error))
    },

    /**
     * Get current basket
     *
     * @param {BasketPayload} payload Current basket
     *    @param {String} payload.basketId  Session id from the basket
     *    @param {String} payload.jwToken  Hash jwt token
     * @returns {Promise<Basket>}
     */
    $_getBasket(payload) {
      return basketQueue.add('get', changedBasket => {
        const jwToken = changedBasket?.jwToken || payload?.jwToken
        const basketId = changedBasket?.basketId || payload?.basketId

        return this.$backend.ovp
          .getBasket({ basketId, jwToken })
          .then(basket => BasketHelper.updateBasketSession(basket))
          .catch(error => Promise.reject(error))
      })
    },

    $_updateBasketLanguage({ language }) {
      const basketLanguage = language?.toUpperCase() || this.$_basket.language

      const isreentry = this.$_basket.mobile?.includes('*')

      if (BasketHelper.isTemporaryBasket()) {
        const basket = cloneDeep(this.$_basket)
        basket.language = basketLanguage
        return BasketHelper.updateBasketSession(basket)
      } else {
        if (this.$_basket.language !== basketLanguage && !isreentry) {
          return BasketHelper.updateBasket({ language: basketLanguage }).then(basket => this.updateBasket(basket))
        }
      }
    },
  },
}
